import { connect } from 'react-redux';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';

import SecurityPatchHistoryTable from 'pages/Devices/components/DeviceServices/SecurityPatchHistoryTable';
import { securityVersionHistoryEntitySelectors, securityVersionHistoryEntityActions } from 'containers/App/modules/entities/securityVersionHistories/securityVersionHistoryEntity.slice';
import securityVersionHistoryReducer,
{ securityVersionHistorySelectors, securityVersionHistoryActions } 
from 'pages/Devices/modules/securityVersionHistory.slice';
import { dbSelectors } from 'containers/App/modules/entities/entities.selectors';
import schema from 'containers/App/modules/api/schema';
import _ from 'lodash';

const withReducer = injectReducer({
	key:     'securityVersionHistories',
	reducer: securityVersionHistoryReducer
});

const mapStateToProps = (state, props) => {
  	const currentSecurityVersionHistoryIds = _.get(state, 'securityVersionHistories.securityVersionHistoriesGrid.currentIds');
  	const securityVersionHistoryData = dbSelectors.selectEntitiesDenormalized([schema.securityVersionHistories], currentSecurityVersionHistoryIds)(state);
	const grid = securityVersionHistorySelectors.selectSecurityVersionHistoryGrid(state);

	return {
		securityVersionHistoryData,
		isLoading: securityVersionHistoryEntitySelectors.selectSecurityVersionHistoriesPending(state),
		grid
	}
};

const withConnect = connect(mapStateToProps, { ...securityVersionHistoryActions, ...securityVersionHistoryEntityActions });

export default compose(
	withReducer,
	withConnect
)(SecurityPatchHistoryTable);
